export default __webpack_public_path__ + "static/media/more.bc1b0ce3.svg";